import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';
import { UniDriver } from '@wix/unidriver-core';

export interface TabsDriver extends BaseDriver {
  getTitles: () => string[];
  clickTabAt: (index: number) => void;
  getActiveTabIndex: () => number;
  isDefaultType: () => boolean;
  getItemsContainerType: () => string;
  getDataHook: () => string;
  getItemsWidth: () => Set<string>;
  hasDivider: () => boolean;
  sideContent: UniDriver;
  getSideContent: Promise<(UniDriver | null)[]>;
  getItemsMaxWidths: () => string[];
}
